import React from 'react';

import BankAccountComponent from '../../../BankAccount';

export default function BankAccount({ refetch, vendor }) {
  return <BankAccountComponent refetch={refetch} vendor={vendor} />;
}
